import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/icn-arrow-right.png'


const _hoisted_1 = { class: "pantry-detail-data-item-image-view" }
const _hoisted_2 = { class: "pantry-detail-data-item-name-text" }
const _hoisted_3 = {
  class: "pantry-detail-data-item-cursor-image",
  src: _imports_0
}
const _hoisted_4 = { class: "pantry-detail-data-item-cursor-image-empty" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryDetailDataValue = _resolveComponent("PantryDetailDataValue")

  return (_openBlock(), _createBlock("div", {
    class: "pantry-detail-data-item",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickItem(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("img", {
        class: "pantry-detail-data-item-image",
        src: _ctx.iconUrl
      }, null, 8, ["src"])
    ]),
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.itemName), 1),
    _createVNode(_component_PantryDetailDataValue, {
      class: "pantry-detail-data-item-value-text",
      itemType: _ctx.itemType,
      value: _ctx.value,
      expirationDate: _ctx.expirationDate,
      stockQuantity: _ctx.stockQuantity,
      notificationStock: _ctx.notificationStock,
      plateData: _ctx.plateData
    }, null, 8, ["itemType", "value", "expirationDate", "stockQuantity", "notificationStock", "plateData"]),
    _withDirectives(_createVNode("img", _hoisted_3, null, 512), [
      [_vShow, _ctx.isShowArrow]
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, null, 512), [
      [_vShow, !_ctx.isShowArrow]
    ])
  ]))
}